<template>
  <div
    :style="{
      position: 'relative',
      marginTopDisabled: `calc(${thumbnailHeight}px / 2)`,
    }"
  >
    <Splide
      class="-splide-bg"
      :options="{
        width: '100%',
        height: 'var(--vh)',

        autoplay: true,
        interval: 8000,
        type: 'fade',
        rewind: true,

        arrows: false,
        cover: true,
        drag: false,
        pagination: false,
      }"
      :style="{
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
      }"
    >
      <SplideSlide :key="src" v-for="src in imageItems">
        <img class="-img" :src="src" :width="WIDTH" :height="HEIGHT" alt="" />
      </SplideSlide>
    </Splide>

    <!--
    <Splide
      class="-splide-thumb"
      ref="thumbnailsRef"
      :options="{
        rewind: true,

        fixedWidth: thumbnailWidth,
        fixedHeight: thumbnailHeight,

        // fixedWidth: '50%',
        // heightRatio: HEIGHT / WIDTH,

        isNavigation: true, // draws border
        arrows: false,
        cover: true,
        drag: false,
        gap: GAP,
        pagination: false,
        // breakpoints: {
        //   640: {
        //     fixedWidth: 66,
        //     fixedHeight: 38,
        //   },
        // },
      }"
      :style="{
        position: 'absolute',
        zIndex: '1',
        top: '0',
        left: '0',
        width: '100%',
        transform: 'translateY(-50%)',
      }"
    >
      <SplideSlide :key="it.label" v-for="it in items">
        <img
          class="-img"
          :src="it.image"
          :width="WIDTH"
          :height="HEIGHT"
          :alt="it.label"
        />
      </SplideSlide>
    </Splide>
    -->
    <!--

  -->
    <Splide
      class="-splide-main"
      ref="mainRef"
      :options="{
        type: 'fade',
        width: '100%',
        height: 'var(--vh)',
        // heightRatio: HEIGHT / WIDTH,
        pagination: false,
        arrows: true,
        drag: true,
        rewind: true,
        // noDrag: '.-overlay',
        // dragMinThreshold: {
        //   mouse: 4,
        //   touch: 10,
        // },

        pagination: true,
      }"
      :style="{ width: '100%' }"
    >
      <SplideSlide :key="it.label" v-for="it in items">
        <img
          class="-img"
          :src="it.image"
          :width="WIDTH"
          :height="HEIGHT"
          :alt="it.label"
        />
        <div class="-link-container">
          <div class="-overlay">
            <div class="text-size-large text-caps">{{ it.label }}</div>
            <div class="text-size-normal text-line-normal" :style="{ maxWidth: '30em' }">
              {{ it.description }}
            </div>
            <RouterLink :to="it.route">
              <NIcon size="40"><IconRight /></NIcon>
            </RouterLink>
          </div>
        </div>
      </SplideSlide>
    </Splide>
  </div>
</template>

<style lang="css">
.-splide-thumb .splide__list {
  justify-content: center;
}
.splide__track--nav > .splide__list > .splide__slide[class] {
  border-width: 2px;
}
.splide__track--nav > .splide__list > .splide__slide.is-active {
  border-color: var(--color-lightest);
}
.splide__pagination {
  top: 1rem;
  bottom: auto;
  gap: 0.5rem;
}
.-splide-main .splide__arrow {
  top: 2rem;
  background: none;
  border-radius: 0;
}
.-splide-main .splide__arrow svg {
  fill: #ffffff;
}
.-splide-bg .splide__slide {
  /* transition: transform 800ms cubic-bezier(.44,.65,.07,1.01); */
  transition-duration: 5000ms !important;
}
</style>

<style scoped lang="scss">
.-link-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: start;
  justify-content: center;
}
.-overlay {
  z-index: 1;
  flex-grow: 1;
  padding: 4rem 1rem 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: #ffffff;
  background: var(--color-overlay_40);
  text-shadow: -1px -1px 3px rgba(0, 0, 0, 0.2), 1px 1px 3px rgba(0, 0, 0, 0.2);
}
.-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  visibility: hidden;
}
</style>

<script setup>
defineOptions({ name: "C_Areas" });
const props = defineProps({
  items: { type: Array },
  imageItems: { type: Array },
});

// https://splidejs.com/
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/vue-splide/css";
import { NIcon } from "naive-ui";
import { ref, onMounted } from "vue";
import { IconRight } from "./icons";

const GAP = 4;
const WIDTH = 1536;
const HEIGHT = 1024;
const thumbnailWidth = 200;
const thumbnailHeight = thumbnailWidth / (WIDTH / HEIGHT);

const mainRef = ref(null);
const thumbnailsRef = ref(null);

// onMounted(() => {
//   mainRef.value.sync(thumbnailsRef.value.splide);
// });
</script>
